import * as React from 'react';
import {Tooltip} from '@mui/material';
import {useAppTranslation} from 'services/i18n';
import {dateToGui} from '../../helpers/date';
import {ApprovalValidityStatus, getApprovalValidity} from 'model/approval';

const styles: { [key in ApprovalValidityStatus]: { background: string, color: string } } = {
    [ApprovalValidityStatus.VALID]: {background: 'var(--color-success-back)', color: '#4A7500'},
    [ApprovalValidityStatus.EXPIRING]: {background: 'var(--color-warning-back)', color: '#8A5A00'},
    [ApprovalValidityStatus.EXPIRED]: {background: 'var(--color-error-back)', color: '#A32409'},
};

export const ApprovalValidityBadge = ({expiration}: { expiration?: Date | string | null }) => {
    const t = useAppTranslation();

    const validity = getApprovalValidity(expiration);
    if (!validity) {
        return <>&mdash;</>;
    }

    // the last day of validity is still valid, but "expires in 0 days" reads wrong
    const label = validity.status === ApprovalValidityStatus.VALID
        ? t('approvals.validity.valid', {date: dateToGui(validity.date, 'M/yyyy')})
        : validity.status === ApprovalValidityStatus.EXPIRING
            ? (validity.days === 0
                ? t('approvals.validity.expiringToday')
                : t('approvals.validity.expiring', {count: validity.days}))
            : t('approvals.validity.expired');

    return <Tooltip title={dateToGui(validity.date)} enterDelay={500}>
        <span className={'tw-rounded-md tw-py-4 tw-px-8 tw-text-12 tw-whitespace-nowrap'}
            style={styles[validity.status]}>{label}</span>
    </Tooltip>;
};
